import React, { useEffect, useState } from "react";
import { useLang } from "../../i18n/LanguageContext";

const LOGO_URL =
  "/assets/adr4solutions-logo.png";

const links = (t) => [
  { id: "services", label: t.nav.services },
  { id: "experience", label: t.nav.experience },
  { id: "method", label: t.nav.method },
  { id: "founder", label: t.nav.founder },
  { id: "contact", label: t.nav.contact },
];

export const Navbar = () => {
  const { lang, setLang, t } = useLang();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  const goTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <header className="navbar fixed top-0 left-0 right-0 z-50" data-testid="adr-navbar">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 h-[80px] flex items-center justify-between">
        <button
          onClick={() => goTo("hero")}
          className="flex items-center gap-3"
          data-testid="nav-logo"
          aria-label="ADR 4 Solutions home"
        >
          <img src={LOGO_URL} alt="ADR 4 Solutions" className="h-11 w-11 lg:h-12 lg:w-12 object-contain" />
          <span className="font-serif text-[20px] lg:text-[22px] tracking-[0.02em] text-[var(--navy)] hidden sm:inline leading-none">
            ADR <span className="text-[var(--champagne)] font-medium">4</span> Solutions
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {links(t).map((l) => (
            <button
              key={l.id}
              className="nav-link"
              onClick={() => goTo(l.id)}
              data-testid={`nav-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <div className="hidden md:flex items-center gap-1 border border-[var(--border-light)] px-2 py-1" data-testid="lang-switch">
            <button
              className={`lang-btn ${lang === "it" ? "active" : ""}`}
              onClick={() => setLang("it")}
              data-testid="lang-it"
            >
              IT
            </button>
            <span className="text-[var(--border-light)]">/</span>
            <button
              className={`lang-btn ${lang === "en" ? "active" : ""}`}
              onClick={() => setLang("en")}
              data-testid="lang-en"
            >
              EN
            </button>
          </div>
          <button
            className="hidden md:inline-flex btn-primary"
            onClick={() => goTo("contact")}
            data-testid="nav-cta-contact"
          >
            {t.nav.cta}
          </button>
          <button
            className="lg:hidden flex flex-col gap-[5px] p-2"
            aria-label="Menu"
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-mobile-toggle"
          >
            <span className={`block w-6 h-[1.5px] bg-[var(--navy)] transition-transform ${open ? "rotate-45 translate-y-[6px]" : ""}`} />
            <span className={`block w-6 h-[1.5px] bg-[var(--navy)] transition-opacity ${open ? "opacity-0" : ""}`} />
            <span className={`block w-6 h-[1.5px] bg-[var(--navy)] transition-transform ${open ? "-rotate-45 -translate-y-[7px]" : ""}`} />
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[var(--border-light)] bg-[var(--ivory)]" data-testid="nav-mobile-menu">
          <div className="px-6 py-8 flex flex-col gap-6">
            {links(t).map((l) => (
              <button
                key={l.id}
                className="nav-link text-left"
                onClick={() => goTo(l.id)}
                data-testid={`nav-mobile-${l.id}`}
              >
                {l.label}
              </button>
            ))}
            <div className="flex items-center gap-3 pt-4 border-t border-[var(--border-light)]">
              <button className={`lang-btn ${lang === "it" ? "active" : ""}`} onClick={() => setLang("it")}>IT</button>
              <span>/</span>
              <button className={`lang-btn ${lang === "en" ? "active" : ""}`} onClick={() => setLang("en")}>EN</button>
            </div>
            <button className="btn-primary self-start" onClick={() => goTo("contact")} data-testid="nav-mobile-cta">
              {t.nav.cta}
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
